import * as React from "react"
import {Image, Row} from "react-bootstrap";
import {useDisclaimersQuery} from "../../../hooks/useDisclaimersQuery";
import Skeleton from "react-loading-skeleton";

export const Disclaimers = () => {
    const {model: {disclaimers}} = useDisclaimersQuery();

    // If there are no disclaimers, return an empty fragment
    if (disclaimers.length === 0) return <></>;

    return (
        <Row className="mx-auto d-block mt-3 p-3 border-bottom mb-3 row">
            <small className="text-muted">
                <div className="d-flex align-items-center mb-1">
                    <Image src="https://static.commerceplatform.services/content/img/prop65-warning.png"
                           className="me-1"
                           alt="propostion 65 warning"
                           height={14}
                           width={18}
                           loading="lazy"
                           decoding="async"/>
                    <div className="fw-bold" style={{lineHeight: 0}}>
                        Warning
                    </div>
                </div>
                <p> California Residents:</p>
                {disclaimers.map(({id, chemical, toxicity}) => (
                    <p key={id}>
                        This product can expose you to {chemical}, which is known to the State of California to
                        cause {toxicity}. For more information go to www.p65warnings.ca.gov.
                    </p>
                ))}
            </small>
        </Row>
    )
}

export const DisclaimersSkeleton = () => {
    return (
        <Row className="mx-auto d-block mt-3 p-3 border-bottom mb-3 row">
            <small className="text-muted">
                <div className="d-flex align-items-center mb-1">
                    <Skeleton count={.2}/>
                    <div className="fw-bold" style={{lineHeight: 0}}>
                        <Skeleton count={.5}/>
                    </div>
                </div>
                <p><Skeleton count={.4} height={30}/></p>
                <p>
                    <Skeleton count={5}/>
                </p>
            </small>
        </Row>
    )
}